import React from "react";

export default function Radio({
  currentValue,
  label,
  onChange,
  value,
  ...forwardedProps
}) {
  return (
    <label>
      <input
        checked={value === currentValue}
        onChange={() => onChange(value)}
        type="radio"
        {...forwardedProps}
      />
      {label}
    </label>
  );
}
